import { ISbStoryData } from '@storyblok/react'
import useTranslation from 'next-translate/useTranslation'
import {
  BlogArticleStoryblok,
  BlogLandingPageStoryblok,
} from '@/types/storyblok-component-types'
import { Hero } from './Hero'
import { HorizontalCard } from './HorizontalCard'
import { VerticleCard } from './VerticleCard'
import { Container, Content, Grid, SectionTitle } from './styles'

export default function BlogAllArticlesPage({
  blok,
  articles,
}: {
  blok: BlogLandingPageStoryblok
  articles: Array<ISbStoryData<BlogArticleStoryblok>>
}) {
  const currentArticles = articles.slice(0, 3)
  const olderArticles = articles.slice(3)

  const { t } = useTranslation()

  return (
    <Container>
      <Hero
        leftImage={blok.left_hero_image}
        rightImage={blok.right_hero_image}
        backgroundColor={blok.hero_background_color?.color}
      />
      <Content>
        {currentArticles.length > 0 && (
          <div>
            <SectionTitle>{t('blog:current_articles')}</SectionTitle>
            {currentArticles.map((article, index) => (
              <HorizontalCard
                key={index}
                reversed={!(index % 2)}
                title={article.content.title}
                image={article.content.image}
                slug={article.full_slug}
                style={{ marginBottom: '2.5rem' }}
                widerText
              />
            ))}
          </div>
        )}
        {olderArticles.length > 0 && (
          <div>
            <SectionTitle>{t('blog:more_articles')}</SectionTitle>
            <Grid style={{ marginBottom: '2rem' }}>
              {olderArticles.map((post, index) => {
                if (typeof post === 'string') {
                  return null
                }

                return (
                  <VerticleCard
                    key={index}
                    title={post.content.title}
                    image={post.content.image}
                    slug={post.full_slug}
                  />
                )
              })}
            </Grid>
          </div>
        )}
      </Content>
    </Container>
  )
}
